// ----------------------------------------------------------------------

const account = {
  displayName: 'Zotech Magic Brain',
  email: 'op@zotech.com.tw',
  photoURL: '/assets/images/avatars/avatar_default.jpg',
};

export default account;
